/**
 * Created by Languagenut on 15/04/2019.
 */


import React  from 'react';
import {Pagination , Media , Nav , NavDropdown , Form , FormControl , Button} from 'react-bootstrap'
import Translation from  '../store/internationalization-store.js';

class TimelineItem extends React.Component {
    constructor(props) {
        super();
        this.props = props;
    }

    render(){
        return <div>
            <Media>
                <img
                    width={64}
                    height={64}
                    className="mr-3"
                    src="https://dummyimage.com/64/"
                    alt="Generic placeholder"
                    />
                <Media.Body>
                    <h5>Media Heading</h5>
                    <p>
                        Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque
                        ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at,
                        tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla.
                        Donec lacinia congue felis in faucibus.
                    </p>
                </Media.Body>
                </Media>
        </div>
    }
}

export default class Timeline extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            FeedList:[],
        };
    }

    constructList(){

    }

    render(){


        let active = 2;
        let items = [];
        for (let number = 1; number <= 5; number++) {
            items.push(
                <Pagination.Item key={number} active={number === active}>
                    {number}
                </Pagination.Item>
            );
        }

        var timeitems = [];

        for(var idx = 0 ; idx < 5; idx++)
        {
            timeitems.push(<TimelineItem/>)
        }

        return <div>
            <div>
            <Nav className="justify-content-end" activeKey="/home">
                <Form inline>
                    <FormControl type="text" placeholder="Search" className="mr-sm-2" />
                    <Button variant="outline-success">Search</Button>
                </Form>
                <NavDropdown title="Filter" id="nav-dropdown">
                    <NavDropdown.Item eventKey="4.2"><small>{Translation.get(355, "Notifications")}</small></NavDropdown.Item>
                    <NavDropdown.Item eventKey="4.2"><small>Attention Required</small></NavDropdown.Item>
                    <NavDropdown.Item eventKey="4.2"><small>Games</small></NavDropdown.Item>
                    <NavDropdown.Item eventKey="4.2"><small>Tests</small></NavDropdown.Item>
                    <NavDropdown.Item eventKey="4.1"><small>Assignments</small></NavDropdown.Item>
                    <NavDropdown.Item eventKey="4.1"><small>Lessons</small></NavDropdown.Item>
                    <NavDropdown.Item eventKey="4.2"><small>Programs & Content</small></NavDropdown.Item>
                    <NavDropdown.Item eventKey="4.2"><small>Rewards & Achivements</small></NavDropdown.Item>
                </NavDropdown>
            </Nav>
                </div>
            <br/>

            {timeitems}

                    <Pagination className="pull-right" size="sm">
                        <Pagination.First />
                        <Pagination.Prev />
                        {items}
                        <Pagination.Next />
                        <Pagination.Last />
                    </Pagination>

            </div>
    }
}